import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { KoanIndexCardStackContentViewModel } from './koan-index-card-stack-content-view-model';

@Component({
  selector: 'app-koan-index-card-stack-content',
  templateUrl: './koan-index-card-stack-content.component.html',
  styleUrls: ['./koan-index-card-stack-content.component.scss'],
  providers: [KoanIndexCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class KoanIndexCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: KoanIndexCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  startScalingAfterNMillisecondsAfterViewInit = 500;
}
